import type { Zeppelin, ZeppelinQueryParams } from '../models/ZeppelinModel';

export default abstract class ZeppelinRepository {
  abstract getZeppelins(params: ZeppelinQueryParams): Promise<Zeppelin[]>;
}
